import { FC, PropsWithChildren } from 'react';

import { buildIncludeParams } from '~/core/shared/api';
import { Module } from '~/core/shared/constants';
import { useModuleScope } from '~/core/shared/contexts/ModuleScopeContext';
import { UserProvider } from '~/core/shared/contexts/UserContext';

export const ScopedUserProvider: FC<PropsWithChildren> = ({ children }) => {
  const module = useModuleScope();

  // Broker portal (and the application module, which normalises to it) needs
  // the user's brokerages; middle-office does not.
  const params =
    module === Module.BrokerPortal
      ? buildIncludeParams(['brokerages'])
      : undefined;

  return <UserProvider params={params}>{children}</UserProvider>;
};
